module.exports = __webpack_public_path__ + "static/img/icon_kong.73efc11.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/voiceScene/icon_kong.png
// module id = 401
// module chunks = 0